var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDoneRound = function SvgDoneRound(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#626262",
    d: "M11.484 3.578a.667.667 0 0 1 1.032.844L6.92 11.261c-.452.553-1.26.65-1.83.223L2.932 9.865a.666.666 0 0 1 .8-1.066l2.156 1.617z"
  })));
};
export default SvgDoneRound;